import { UserPermission } from '@/modules/permission/enum';
export const attributeRoutes = [
    {
        path: '',
        name: 'Attribute',
        exact: true,
        component: () => import('../views/AttributeIndex.vue'),
        meta: {
            breadcrumb: [{ label: 'All Attributes' }],
            permissions: [UserPermission.READ_ASSESSMENT_ATTRIBUTES],
        },
    },
];
